import { useEffect, useRef } from 'react';

export function useScrollPause() {
  const scrollContainerRef = useRef(null);
  const isHovering = useRef(false);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleMouseEnter = () => {
      isHovering.current = true;
      container.style.animationPlayState = 'paused';
    };

    const handleMouseLeave = () => {
      isHovering.current = false;
      container.style.animationPlayState = 'running';
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return scrollContainerRef;
}